import { Switch } from '@e2n/ui';
import { useTranslation } from 'react-i18next';
import { toast } from '@e2n/ui/v2';
import { useZugangAktivierung } from '../hooks/useZugangAktivierung';

type ZugangSwitchProps = {
  uidZugang: string;
  aktiv: boolean;
};

export function ZugangSwitch({ uidZugang, aktiv }: ZugangSwitchProps) {
  const { t } = useTranslation();
  const { setzeAktiv, loading } = useZugangAktivierung(uidZugang);

  async function handleChange() {
    if (await setzeAktiv(!aktiv)) {
      return;
    }

    toast({
      variant: 'error',
      title: t('domain.e2nApi.zugaenge.tabelle.aenderungFehlgeschlagen'),
    });
  }

  return (
    <Switch
      checked={aktiv}
      disabled={loading}
      onCheckedChange={handleChange}
      aria-label={t(
        aktiv
          ? 'domain.e2nApi.zugaenge.tabelle.zugangDeaktivieren'
          : 'domain.e2nApi.zugaenge.tabelle.zugangAktivieren',
      )}
    />
  );
}
